var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "buy-panel-size-selection"
  }, [_c('form', {
    staticClass: "buy-panel-size-selection-form"
  }, [_c('div', {
    ref: "buyPanelFormContainer",
    staticClass: "buy-panel-size-selection-form-container"
  }, _vm._l(_vm.itemsToPurchase, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "buy-panel-size-selection-form-container-sizeqty"
    }, [_vm.showSizeDropdown ? _c('div', {
      staticClass: "buy-panel-size-selection-form-container-sizeqty-wrapper size-select-wrapper"
    }, [_c('div', {
      staticClass: "buy-panel-size-selection-form-container-sizeqty-wrapper-ttl select-wrapper-text"
    }, [_vm._v("\n            " + _vm._s(_vm.translations.buyPanelSize) + "\n          ")]), _vm.$props.showSizeGuide && index === 0 ? _c('a', {
      on: {
        "click": _vm.openGuideSizeModal
      }
    }, [_vm._v("\n            " + _vm._s(_vm.translations.buyPanelSizeGuide) + "\n          ")]) : _vm._e(), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: item.size,
        expression: "item.size"
      }],
      attrs: {
        "disabled": _vm.buyPanelIsLoading,
        "name": "buy-panel-size-selection-form-container-sizeqty-wrapper-select"
      },
      on: {
        "change": [function ($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
            return o.selected;
          }).map(function (o) {
            var val = "_value" in o ? o._value : o.value;
            return val;
          });
          _vm.$set(item, "size", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
        }, function ($event) {
          return _vm.onChangeSize($event.target.value, index);
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "",
        "selected": ""
      }
    }, [_vm._v(_vm._s(_vm.translations.selectText))]), _vm._l(_vm.sizes.short_display_values || _vm.sizes.values, function (value, indexForSizes) {
      return _c('option', {
        key: value,
        domProps: {
          "value": _vm.sizes.identifier[indexForSizes]
        }
      }, [_vm._v("\n              " + _vm._s(value) + "\n            ")]);
    })], 2)]) : _vm._e(), !_vm.disableQuantity ? _c('div', {
      staticClass: "buy-panel-size-selection-form-container-sizeqty-wrapper qty-select-wrapper"
    }, [_vm.isQuantityLabelHide && !_vm.isFavoritesOnly || !_vm.isQuantityLabelHide ? _c('div', {
      staticClass: "buy-panel-size-selection-form-container-sizeqty-wrapper-ttl select-wrapper-text"
    }, [_vm._v("\n            " + _vm._s(_vm.translations.buyPanelQTY) + "\n          ")]) : _vm._e(), _vm.isQuantitySelectHide && !_vm.isFavoritesOnly || !_vm.isQuantitySelectHide ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: item.quantity,
        expression: "item.quantity"
      }],
      staticClass: "buy-panel-size-selection-form-container-sizeqty-wrapper-select",
      attrs: {
        "disabled": _vm.buyPanelIsLoading
      },
      on: {
        "change": [function ($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
            return o.selected;
          }).map(function (o) {
            var val = "_value" in o ? o._value : o.value;
            return val;
          });
          _vm.$set(item, "quantity", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
        }, function ($event) {
          return _vm.onChangeQuantity($event.target.value, index);
        }]
      }
    }, _vm._l(_vm.maxQuantity, function (indexForQuantity) {
      return _c('option', {
        key: indexForQuantity,
        domProps: {
          "value": indexForQuantity
        }
      }, [_vm._v("\n              " + _vm._s(indexForQuantity) + "\n            ")]);
    }), 0) : _vm._e()]) : _vm._e()]);
  }), 0)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }